class RecaptchaService {
  constructor () {
    this.enabled = false
    this.src = null
    this.key = null
  }

  init (config) {
    if (config.recaptcha && config.recaptcha.enabled) {
      this.src = config.recaptcha.src
      this.key = config.recaptcha.key
      this.enabled = true
    }
  }

  getScriptSrc () {
    return this.src
  }

  async getToken () {
    if (!this.enabled) {
      return
    }

    const siteKey = this.key

    return Promise.race([
      createTimeout(5000),
      new Promise(async (resolve, reject) => {
        try {
          window.grecaptcha.ready(async function () {
            try {
               const token = await window.grecaptcha.execute(siteKey, {action: 'signup'})
               resolve(token)
            } catch (e) {
              // eslint-disable-next-line
              console.log('grecaptcha execute error', e)
              reject(e)
            }
          })
        } catch (e) {
          // eslint-disable-next-line
          console.log('grecaptcha ready error', e)
          reject(e)
        }
      })
    ])
  }
}

function createTimeout (timeout) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error('recaptcha get token timeout'))
    }, timeout)
  })
}

const instance = new RecaptchaService()
export default instance
